import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { queryClient } from "../../queryClient.ts";
import { Urls } from "../../urls.ts";

export const useUpdateBooking = (id: string) => {
  const { token } = useAuth();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: any) => {
      const response = fetch<{ paymentLink: string; bookingId: number }>(`${Urls.Booking}/${data.id || id}`, {
        method: "PUT",
        body: JSON.stringify({
          ...data,
          id: undefined
        }),
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      }, true, token);

      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["booking-id", id] });
    },
    onError: (error) => {
      toast.error(error?.message || "Error updating booking");
    },
  });
};
